import { ReactComponent as MainLogo } from 'assets/img/main-logo.svg';
import RevxFlexLayout from 'components/RevxFlexLayout';
import appService from 'services/appService';
import { SYSTEM_UNAVAILABLE_STATUS_KEY } from 'utils/constants';
import { useEffect } from 'react';
import './index.less';

const REFRESH_TIME = 5000;

const Unavailable = () => {
  useEffect(() => {
    let refreshWindowTimer: ReturnType<typeof setTimeout>;
    const refreshWindow = () => {
      refreshWindowTimer = setTimeout(async () => {
        try {
          const res = await appService.heartbeatCheck();
          res.text().then((r) => {
            if (r === 'pong') {
              localStorage.setItem(SYSTEM_UNAVAILABLE_STATUS_KEY, 'false');
              window.location.href = window.location.origin;
              clearTimeout(refreshWindowTimer);
            } else {
              refreshWindow();
            }
          });
        } catch {
          refreshWindow();
        }
      }, REFRESH_TIME);
    };
    refreshWindow();
    return () => {
      clearTimeout(refreshWindowTimer);
    };
  }, []);

  return (
    <RevxFlexLayout className="unavailable-page" justify="justify-center">
      <RevxFlexLayout justify="justify-start" wrap="wrap" direction="column">
        <RevxFlexLayout className="unavailable-page__logo">
          <MainLogo />
        </RevxFlexLayout>
        <RevxFlexLayout
          className="unavailable-page__status-tips"
          justify="justify-center"
        >
          <p>revshop is currently down for maintenance.</p>
        </RevxFlexLayout>
        <RevxFlexLayout
          className="unavailable-page__warm-tips"
          justify="justify-center"
        >
          <p>We will be back shortly. Thanks for your patience.</p>
        </RevxFlexLayout>
      </RevxFlexLayout>
    </RevxFlexLayout>
  );
};
export default Unavailable;
